module.exports = __webpack_public_path__ + "static/media/tk-logo.a2902bdc.png";